// SmallBox.tsx
import React, { useEffect, useState } from "react";
import "../styles/SmallBox.css";

const wsURL = "wss://sslsocket.aifanet.com/5.250.255.84/12671";

interface SarrafiyeValue {
  bid: string;
  ask: string;
}

const initialSarrafiyeValues: { [key: string]: SarrafiyeValue } = {
  "ESKİ ÇEYREK": { bid: "-", ask: "-" },
  "ÇEYREK": { bid: "-", ask: "-" },
  "ESKİ YARIM": { bid: "-", ask: "-" },
  "YARIM": { bid: "-", ask: "-" },
  "ESKİ TAM": { bid: "-", ask: "-" },
  "TAM": { bid: "-", ask: "-" },
  "ESKİ GREMSE": { bid: "-", ask: "-" },
  "GREMSE": { bid: "-", ask: "-" },
  "ESKİ ZIYNET 5": { bid: "-", ask: "-" },
  "ZIYNET 5": { bid: "-", ask: "-" },
  "ESKİ ATA": { bid: "-", ask: "-" },
  "ATA": { bid: "-", ask: "-" },
  "ESKİ ATA 5": { bid: "-", ask: "-" },
  "ATA 5": { bid: "-", ask: "-" },
  "REŞAT LİRA": { bid: "-", ask: "-" },
  "1 GRAM": { bid: "-", ask: "-" },
  "5 GRAM": { bid: "-", ask: "-" },
  "10 GRAM": { bid: "-", ask: "-" },
  "20 GRAM": { bid: "-", ask: "-" },
  "50 GRAM": { bid: "-", ask: "-" },
  "100 GRAM": { bid: "-", ask: "-" },
  "250 GRAM": { bid: "-", ask: "-" },
  "500 GRAM": { bid: "-", ask: "-" },
};

export const sarrafiyeValues = initialSarrafiyeValues;

interface SmallBoxProps {
  label: string;
  type: "bid" | "ask";
}

const SmallBox: React.FC<SmallBoxProps> = ({ label, type }) => {
  const [values, setValues] = useState(initialSarrafiyeValues);

  useEffect(() => {
    let ws: WebSocket;
    let reconnectTimeout: NodeJS.Timeout;

    const connectWebSocket = () => {
      ws = new WebSocket(wsURL);

      ws.onopen = () => {
        console.log("WebSocket bağlantısı başarıyla kuruldu.");
      };

      ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);

          if (Array.isArray(data)) {
            setValues(prevValues => {
              const updatedValues = { ...prevValues };
              
              data.forEach((item) => {
                if (initialSarrafiyeValues[item.Code]) {
                  updatedValues[item.Code] = {
                    bid: item.Bid ? item.Bid.toFixed(3) : "-",
                    ask: item.Ask ? item.Ask.toFixed(3) : "-",
                  };
                }
              });

              Object.assign(sarrafiyeValues, updatedValues);
              return updatedValues;
            });
          }
        } catch (error) {
          console.error("WebSocket mesajını işlerken hata oluştu:", error);
        }
      };

      ws.onclose = () => {
        console.log("WebSocket bağlantısı kapatıldı. Yeniden bağlanıyor...");
        reconnectTimeout = setTimeout(connectWebSocket, 5000);
      };

      ws.onerror = (error) => {
        console.error("WebSocket hata:", error);
      };
    };

    connectWebSocket();

    return () => {
      if (ws) {
        ws.close();
      }
      if (reconnectTimeout) {
        clearTimeout(reconnectTimeout);
      }
    };
  }, []);

  const content = values[label]?.[type] || "-";
  console.log("SmallBox içeriği:", content); // İçerik kontrolü
  return <div className="small-box">{content}</div>;
};

export default SmallBox;